import React from 'react';
import styled from 'styled-components';
import { StyledPasswordHide, StyledPasswordShow } from '~/components/common/privacy-button/styles';

interface PrivacyButtonProps {
    type: 'Show' | 'Hide';
    onClick?: () => void;
    className?: string;
    id?: string;
    ariaLabelShow?: string;
    ariaLabelHide?: string;
}

const StyledIconButton = styled.button`
    background: none;
    border: none;
`;

const PrivacyButton = ({
    type,
    onClick,
    className,
    id,
    ariaLabelShow,
    ariaLabelHide,
    ...rest
}: PrivacyButtonProps) => {
    const isPasswordVisible = type === 'Hide';
    const Icon = isPasswordVisible ? StyledPasswordHide : StyledPasswordShow;
    const ariaLabel = isPasswordVisible ? ariaLabelHide : ariaLabelShow;

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick?.();
        }
    };

    return (
        <StyledIconButton
            type="button"
            id={id}
            aria-label={ariaLabel}
            aria-pressed={isPasswordVisible}
            className={className}
            onClick={onClick}
            onKeyDown={handleKeyDown}
            {...rest} // <-- forward any extra props (including data-*)
        >
            <Icon aria-hidden="true" focusable="false" />
        </StyledIconButton>
    );
};

export default PrivacyButton;
